import {ICost, IResortFeeDetail, IRetail, ISalesInformation} from "libraries/service/resources/model/search/IBooking";
import { IHotelQuoteDetails } from "libraries/service/resources/hotel/hotel-quotation";
import { IMealplan, IWebSite } from "./details";
import { IPenalty } from "libraries/service/resources/hotel/IResourceHotel";
import { HotelQuoteStatus } from "libraries/service/resources/hotel/ISearchResponse";
import { EXApply, IBookingPropertyDescription, XSellLocationEnum } from "../../service/resources/booking/interfaces/IGetBookings";
import { IAddress } from "libraries/hotel/models/address";
import { IAlternative } from "./hotel";

export interface IQuoteRequestForResource {
    traveller: ITravellers;
    segment: ISegment[];
    language: string;
    transactionId?: string;
}

export interface IRootQuote {
    key: string;
    status: string;
    message: string[];
    topic: string;
    traveller: ITravellers;
    segment: ISegment[];
    quantity: IQuantity;
    property: IProperties;
    quote: IQuotes;
    rooming: IRooming;
    currency?: any;
}

export interface IRooming {
    [key: string]: ITravellers;
}
export interface IQuotes {
    [key: string]: IQuote;
}

export interface IQuote {
    hostCode: string;
    property: string;
    host: string|{ code: string };
    xId: string;
    total: ITotal;
    syscode: string;
    detail: IHotelQuoteDetails;
    rank: string;
    dateLastCancellationWithoutPenalty: string;
    alternative: string[];
    mealplan?: IMealplan;
    resortFees?: IResortFeeDetail | IResortFeeDetail[];
    salesInformation?: ISalesInformation | ISalesInformation[];
    status: HotelQuoteStatus;
    supplement?: IQuoteSupplement | IQuoteSupplement[];
    keywords: string[];
    descriptions?: IBookingPropertyDescription[];
}

export interface IQuoteSupplement {
    included: boolean;
    xSellLocation: XSellLocationEnum; //§TODO: make enum when all values will be knowned.
    quantity: number;
    value: ITotal;
    total: ITotal;
    traveller?: string[];
    segment?: string;
    room?: string;
    code?: string;
    name?: string;
}

export interface ITotal {
    cost: ICost;
    retail?: IRetail;
}

export interface IProperties {
    [key: string]: IProperty;
}

export interface IProperty {
    descriptions?: IQuotePropertyDescription[];
    id: string;
    owner: string;
    syscode: string;
    name: string;
    address: IAddress;
    telephones: string[];
    /** @deprecated use preferably `sites` when available */
    site: string;
    sites: IWebSite[];
    source?: {
        code: string;
        shortcut: string;
    };
    airportClosest: string[];
    geoposition: IGeoposition;
    keyword: string[];
    nature: string;
    rating: IRating;
    host: string | IHosts;
    hostCode: string;
    zipcode: string | number;
    city: string;
    country: string;
    trip: string;
    state: string;
    property?: string;
    alternative?: string[];
    mealplan?: IMealplan;
    alternatives?: IAlternative[];
}

export interface IHosts {
    [key: string]: {
        syscode: string;
        owner: string;
        code: string;
        property: {descriptions: IQuotePropertyDescription[]};
    };
}

export interface IQuotePropertyDescription {
    index: string;
    languageCode: string;
    title: string;
    type: {
        xCode: string;
        xApply?: EXApply;
    };
    textLines: string[];
}

export interface IGeoposition {
    latitude: string;
    longitude: string;
}

export interface IQuantity {
    adult: number;
    child: number;
    infant: number;
    rooming?: number;
    night?: number;
    property?: number;
    quote?: number;
}

export interface ITravellers {
    [key: string]: ITraveller;
}

export interface ITraveller {
    id: string;
    type: string;
    typeInput: string;
    xId: string;
}

export interface ISegment {
    begin: string;
    end: string;
    rooming?: ISegmentRooming;
    duration: IDuration;
    property: ISegmentProperty;
    rating?: IRating;
}

export interface IDuration {
    night: number;
}

export interface ISegmentProperty {
    host: string[];
    text: string;
}

export interface IRating {
    standardisationBody: number;
    traveller: number;
}

export interface ISegmentRooming {
    [key: string]: ISegmentRoomingTraveller;
}

export interface ISegmentRoomingTraveller {
    traveller: string[];
}

export interface ITripPropertyQuote {
    trip: string;
    property: IProperty;
    quote: IQuote;
}

export enum RoomCode {
    Single = 'single',
    Double = 'double',
    Triple = 'triple',
    Quad = 'quad',
    Twin = 'twin',
    Quint = 'quint',
    Sext = 'sext',
    Sept = 'sept',
    Eight = 'eight',
    Nine = 'nine',
    Ten = 'ten',
    Family = 'family',
    Dormitory = 'dormitory',
    Unknown = 'unknown',
}

export interface ILanguageText {
    text: string;
    language: string;
}

export interface IRoomDetail {
    code: string;
    host: string;
    name: ILanguageText;
    penalty?: IPenalty;
    syscode: string;
    xCode: RoomCode;
    xId: string;
    rooming?: string;
    unit?: {
        cost: { [key: string]: number }
        retail?: { [key: string]: number }
    };
    total?: {
        cost: { [key: string]: number }
        retail?: { [key: string]: number }
    };
    mealplan?: IMealplan;
    dateLastCancellationWithoutPenalty?: string;
    status: RoomStatus;
}

export enum RoomStatus {
    Request = "Request",
    Available = "Available"
}
